//

import { normalize } from 'normalizr';
import moment from 'moment';

import { simplApi } from '../../api/simplApi';

import { numberRange } from './schemas';
import { dateFormat } from '../../helpers/formats';
import { receiveObjectNumber } from './objectnumber';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_NUMBERRANGE = 'REQUEST_NUMBERRANGE';
export const RECEIVE_NUMBERRANGE = 'RECEIVE_NUMBERRANGE';
export const SET_NUMBERRANGE = 'SET_NUMBERRANGE';
export const SET_NUMBERRANGE_FORM = 'SET_NUMBERRANGE_FORM';
export const CLOSE_NUMBERRANGE_FORM = 'CLOSE_NUMBERRANGE_FORM';
export const REMOVE_NUMBERRANGE = 'REMOVE_NUMBERRANGE';

// ------------------------------------
// Actions
// ------------------------------------

export function requestNumberRange() {
  return {
    type: REQUEST_NUMBERRANGE,
  };
}

export function receiveNumberRange(numberRanges) {
  return {
    type: RECEIVE_NUMBERRANGE,
    payload: {
      numberRanges,
    },
  };
}

export function setNumberRange(numberRangeId) {
  // console.log('action setNumberRange', numberRangeId);
  return {
    type: SET_NUMBERRANGE,
    payload: numberRangeId,
  };
}

export function setNumberRangeForm(numberRangeId = '') {
  return {
    type: SET_NUMBERRANGE_FORM,
    payload: numberRangeId,
  };
}

export function closeNumberRangeForm() {
  return {
    type: CLOSE_NUMBERRANGE_FORM,
  };
}

export const fetchNumberRange = numberRangeId => dispatch => {
  dispatch(requestNumberRange());

  const url =
    typeof numberRangeId !== 'undefined' && numberRangeId !== null
      ? `numberRange/${numberRangeId}`
      : 'numberRange';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedNumberRanges;

        if (typeof json.id === 'undefined') {
          // console.log('multiple number ranges');
          preparedNumberRanges = normalize(json, [numberRange]);
        } else {
          // console.log('solo number range');
          preparedNumberRanges = normalize(json, {
            numberRange,
          });
        }

        // // console.log('prepping json', json, preparedNumberRanges);

        dispatch(
          receiveNumberRange(preparedNumberRanges.entities.numberRanges),
        );
        dispatch(
          receiveObjectNumber(preparedNumberRanges.entities.objectNumbers),
        );
      }
    });
};

export function removeNumberRange(numberRangeId) {
  return {
    type: REMOVE_NUMBERRANGE,
    payload: numberRangeId,
  };
}

export const deleteNumberRange = numberRangeId => dispatch => {
  const url = `numberRange/${numberRangeId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }
        dispatch(handleApiError(json));
      } else {
        dispatch(removeNumberRange(numberRangeId));
      }
    });
};

export const saveNumberRange = newNumberRange => dispatch => {
  // console.log('attempting to save a number range!', newNumberRange);

  dispatch(requestNumberRange());

  let url = 'numberRange/';
  const options = { method: 'post', body: newNumberRange };
  if (typeof newNumberRange.id !== 'undefined' && newNumberRange.id !== null) {
    url = `${url}${newNumberRange.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }
        dispatch(handleApiError(json));
      } else {
        const preparedNumberRanges = normalize(json, numberRange);

        dispatch(
          receiveNumberRange(preparedNumberRanges.entities.numberRanges),
        );
        dispatch(
          receiveObjectNumber(preparedNumberRanges.entities.objectNumbers),
        );
        dispatch(fetchTotalData());
      }
    });
};

export const actions = {
  requestNumberRange,
  receiveNumberRange,
  fetchNumberRange,
  setNumberRange,
  setNumberRangeForm,
  closeNumberRangeForm,
  saveNumberRange,
  deleteNumberRange,
  removeNumberRange,
};

const NUMBERRANGE_ACTION_HANDLERS = {
  [REQUEST_NUMBERRANGE]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_NUMBERRANGE]: (state, action) => ({ ...state, current: action.payload }),
  [SET_NUMBERRANGE_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_NUMBERRANGE]: (state, action) => ({
    ...state,
    numberRanges: _.omit(state.numberRanges, action.payload),
  }),
  [CLOSE_NUMBERRANGE_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_NUMBERRANGE]: (state, action) => {
    const stateNumberRanges = state.numberRanges;

    _.forOwn(action.payload.numberRanges, (_numberRange, id) => {
      const newNumberRange = _numberRange;

      newNumberRange.createdDate = moment(_numberRange.created_at).format(
        dateFormat,
      );

      if (typeof stateNumberRanges[id] === 'object') {
        Object.assign(
          stateNumberRanges[id],
          stateNumberRanges[id],
          newNumberRange,
        );
      } else {
        stateNumberRanges[id] = newNumberRange;
      }
    });

    return {
      ...state,
      numberRanges: stateNumberRanges,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  current: null,
  formOpen: false,
  formTarget: null,
  fetching: false,
  numberRanges: {},
};
export default function numberRangeReducer(state = initialState, action) {
  const handler = NUMBERRANGE_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/numberrange.js